import { FormLayout } from "@careinfo/layout";
import { useForm } from "react-hook-form";
import BrokerForm from "./BrokerForm";

const CreateBroker = (props: any) => {
  const {
    handleSubmit,
    register,
    formState: { errors },
    setError,
  } = useForm<any>({});
  const { handleCreate, isLoading } = props;
  return (
    <FormLayout
      handleSubmit={handleSubmit}
      handleFormSubmit={handleCreate}
      setError={setError}
      buttonLabel={"Create"}
      isLoading={isLoading}
    >
      <BrokerForm register={register} errors={errors} />
    </FormLayout>
  );
};

export default CreateBroker;
